import React from 'react'
import './album'


const DataTL = ({mes, detalle}) => {

    const datos = (mes, detalle) => {
        if(mes && detalle){
            return (
                <div className='time-line-border'>
                <div className="point"></div>
                    <div className='date'>
                        <p><b>{mes}</b></p>
                        <p>{detalle}</p>
                    </div>
                </div>)
        } else {
            return(
                <div className='time-line-border'>
                    <div className='date'>
                        <p>{detalle}</p>
                    </div>
                </div>
            )
        }
    }
  return (
        datos(mes, detalle)
  )
}

export default DataTL
